import { decimal } from '../formatters';
import zeroReducer from './zeroReducer';

const labelCallback = context => {
    const yLabel = context.parsed.y;
    const label = context.dataset.label;
    const value = decimal(yLabel);
    const formattedLabel = `${label}: ${value}s`;
    return formattedLabel;
};

const secConfig = () => {
    return {
        scales: {
            y: {
                beginAtZero: true,
                type: 'linear',
                ticks: {
                    callback: val => {
                        return zeroReducer(val);
                    },
                },
                title: {
                    display: true,
                    text: 'seconds',
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: labelCallback,
                },
            },
        },
    };
};

export default secConfig;
